import { Link, useOutletContext } from "react-router-dom";
import CoreDefault from "@/core/Defaults";
import { isEmpty } from "lodash";
// components
import RMDRSocialShare from "@/components/RMDRSocialShare";
// type
import { TMainPageLayoutV3 } from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
// utilities
import { metaDataLanguageVersion, outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import TClientTagList from "@/cms/types/TClientTagList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";


type TRender = {
    languageVersion:TLanguageVersionList|TLanguageVersionDetail;
    tags?:TClientTagList[];
}

const Render = ( props:TRender ) => {

    const { siteSettingPayload, webApplicationLanguageISOCode } = useOutletContext<TOutletContext>();

    const shareString = metaDataLanguageVersion("shareString", siteSettingPayload.languageVersions);

    return (
        <div className="row tag-share-wrap mt-4 mb-4">
            <div className="col-lg-8 col-12">
                <div className="tagcloud">
                    {
                        props.tags && props.tags.map((item) => (
                            <Link to={`/${webApplicationLanguageISOCode}/search?tids=${item.id}`}>{item.name}</Link>
                        ))
                    }
                </div>
            </div>
            <div className="col-lg-4 col-12 mt-3 mt-lg-0 text-lg-end">
                <div className="social-share" style={{lineHeight:"2.6rem"}}>
                    <span className="me-3">{shareString} </span>
                    <RMDRSocialShare
                        title={props.languageVersion.name}
                        contentRouteNavigationURL={`${CoreDefault.url}${props.languageVersion.contentRouteNavigationURL}`}
                    />
                </div>
            </div>
        </div>
    )
}

const MNPG039 = ( props:TMainPageLayoutV3 ) => {
    console.log("MNPG039.rendered: ", props);

    if ( !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;
    const languageVersion = outerNameDescriptionLanguageVersion(props.params["contentDetails"].languageVersions);

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersion={languageVersion}
        tags={props.params["contentDetails"].tags} 
    />

}

export default MNPG039;
